import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ClientService, TimeconversionService } from '@fitness-force/api';
import { Ienum, PlanCategory, StaffStatus, SubscriptionStatus } from '@fitness-force/enum';
import { AppErrors } from '@fitness-force/errors';
import { ChangeSessionOwner, STATE_STAFF_LIST, SubscriptionById, SubscriptionService } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import {  ShortNamePipe} from '@fitness-force/pipes/short-name'
import { ToastMessageService } from '@fitness-force/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PopoverModule } from 'primeng/popover';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';

import { BehaviorSubject, map, Observable, of } from 'rxjs';
import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { SubscriptionStartEndDateEditComponent } from '../subscription-start-end-date-edit/subscription-start-end-date-edit.component';
import { MembershipSessionsEditComponent } from '../membership-sessions-edit/membership-sessions-edit.component';
import { LazyLoadEvent } from 'primeng/api';


@Component({
  selector: 'app-subscription-services',
  templateUrl: './subscription-services.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    ButtonModule,
    InputNumberModule,
    InputTextModule,
    TableModule,
    PopoverModule,
    AssignedToComponent,
    AvatarModule,
    ShortNamePipe,
    SubscriptionStartEndDateEditComponent,
    MembershipSessionsEditComponent,
    TranslateModule],
})
export class SubscriptionServicesComponent implements OnInit {
  @Input() subscription: SubscriptionById;
  @Input('clientId') clientId: number = 0;
  @Input('tenantId') tenantId: number = 0;
  @Input('restrictToDateChange') restrictToDateChange: boolean=false;

  sessionOwner = new BehaviorSubject<number[]>([-1]);
  subscriptionService$ = new BehaviorSubject<SubscriptionService[]>([]);
  subscriptionCategory: PlanCategory;
  showSkeleton: boolean = true;
  assignSessionOwnerModal = new BehaviorSubject(false);
  selectedService: SubscriptionService;
  changeSessionOwnerForm: UntypedFormGroup = new UntypedFormGroup({});
  getAccessedStaffList$: Observable<any> | any;
  showEditStartEndDate: boolean = false;
  membershipId: number = 0;
  showEditMembershipSessions: boolean = false;

  constructor(
    public translate: TranslateService,
    private toastMessageService: ToastMessageService,
    private store: Store,
    private timeService: TimeconversionService,
    private clientService: ClientService
  ) { }


  ngOnInit(): void {
    if(this.subscription){
      this.mapServiceTable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.subscription && changes.subscription.currentValue != changes.subscription.previousValue) {
      this.mapServiceTable();
    }
  }


  mapServiceTable() {
    let services: SubscriptionService[] = [];
    this.subscriptionCategory = this.subscription.subscription_category;
    if (this.subscription.recurring_template_non_recurring_services) {
      this.subscription.recurring_template_non_recurring_services.forEach(o => {
        o.is_recurring = false;
        o.subscription_category = this.subscription.subscription_category;
        //o.available_sessions = o.service_sessions - o.service_sessions_used || 0;
        o.service_start_date = this.timeService.ConvertUTCToLocalDateTime(o.service_start_date);
        o.service_end_date = this.timeService.ConvertUTCToLocalDateTime(o.service_end_date);
        o.client_membership_id = o.client_membership_id;
        // if (o.service_behaviour == ServiceBehaviour.AppointmentPackage || o.service_behaviour.toString() == ServiceBehaviour[ServiceBehaviour.AppointmentPackage]) {
        this.changeSessionOwnerForm.addControl('SelectedAssignedFormControl_' + o.service_id.toString(), new UntypedFormControl(o.service_session_owner_id, []));
        //}
        services.push(o);
      });
    }
    if (this.subscription.recurring_template_recurring_services) {
      this.subscription.recurring_template_recurring_services.forEach(o => {
        o.is_recurring = true;
        o.subscription_category = this.subscription.subscription_category;
        //o.available_sessions = o.service_sessions;
        o.client_membership_id = o.client_membership_id;
        //if (o.service_behaviour == ServiceBehaviour.AppointmentPackage || o.service_behaviour.toString() == ServiceBehaviour[ServiceBehaviour.AppointmentPackage]) {
        this.changeSessionOwnerForm.addControl('SelectedAssignedFormControl_' + o.service_id.toString(), new UntypedFormControl(o.service_session_owner_id, []));
       //}
        services.push(o);
      });
    }
    this.showSkeleton = false;
    this.subscriptionService$.next(services);
    this.GetStaffs();
  }

  loadData(event: LazyLoadEvent) {
    this.subscriptionService$.next(this.subscriptionService$.getValue());
  }

  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        let validStaff: number[] = [];
        this.getAccessedStaffList$ = data.staffList.filter((staff: any) => {
          let oStaffStatus = this.OStaffStatus.find(
            (o: any) => o.value == staff.status || o.key == staff.status
          );
          if (
            oStaffStatus!.value == StaffStatus.Active ||
            oStaffStatus!.key == StaffStatus.Active
          ) {
            if (staff.role.toLowerCase() == 'admin' || (staff.role.toLowerCase() == 'staff')) {
              validStaff.push(staff.id);
              return staff;
            }
          }
        });
        this.sessionOwner.next(validStaff);
      }
    });
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus)
      .filter((key) => typeof key[1] != 'number')
      .map(([key, value]) => ({ key, value }));
  }

  assignSessionOwner(service: SubscriptionService) {
    this.selectedService = service;
    this.assignSessionOwnerModal.next(true);
  }

  getSelectedStaff(trainer: any, service: SubscriptionService) {
    let sessionOwnerServiceIds: ChangeSessionOwner = {} as ChangeSessionOwner;
    if (trainer && trainer.id) {
      sessionOwnerServiceIds.svc_session_owner_id = trainer.id;
    }
    else {
      sessionOwnerServiceIds.svc_session_owner_id = 0;
    }
    this.clientService.ChangeSessionOwner(this.subscription.tenant_id, this.subscription.client_id, this.subscription.id, service.client_membership_id, sessionOwnerServiceIds)
      .subscribe({
        next: async (data: any) => {
          this.translate
            .get('SUBSCRIPTIONS.MSG_SESSION_OWNER_UPDATED')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });

          let serviceList = this.subscriptionService$.getValue();
          serviceList.forEach(o => {
            if (o.client_membership_id == service.client_membership_id)
              o.service_session_owner_id = trainer.id;
          });
          this.subscriptionService$.next(serviceList);
          this.assignSessionOwnerModal.next(false);
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      this.toastMessageService.showErrorMessage(error.originalError.error.errorMessage);
    }
  }

  setAsObserVable(data: any) {
    return of(data);
  }

  getSessionOwnerFC(serviceId: string): AbstractControl | null {
    return this.changeSessionOwnerForm.get(serviceId);
  }

  getSessionOwnerId(sessionOwnerId: number) {
    return new BehaviorSubject(sessionOwnerId);
  }

  GetStaff(staffId: number): Observable<unknown> {
    return this.store.select(STAFF_STATE).pipe(map((staffs: STATE_STAFF_LIST) => {
      return staffs.staffList.find((staff) => staff.id == staffId);
    }));
  }

  ChangeDate(service: SubscriptionService) {
    this.membershipId = service.client_membership_id;
    this.showEditStartEndDate = true;
  }

  closeDateChangeEvent(event: any) {
    this.showEditStartEndDate = false;
    this.subscription = event;
  }

  ChangeMembershipSessions(service: SubscriptionService) {
    this.membershipId = service.client_membership_id;
    this.showEditMembershipSessions = true;
  }

  closeMembershipSessionsEvent(event: any) {
    this.showEditMembershipSessions = false;
    this.subscription = event;
  } 

  public get PlanCategory() {
    return PlanCategory;
  }

  IsSubscrptionVoidOrCancelled() {
    var subscrptionStatus = SubscriptionStatus[this.subscription.status as keyof typeof SubscriptionStatus];
    return (subscrptionStatus == SubscriptionStatus.Void || subscrptionStatus == SubscriptionStatus.Cancelled || subscrptionStatus == SubscriptionStatus.Upgraded);
  }

  CanEditDates() {
    var subscrptionStatus = SubscriptionStatus[this.subscription.status as keyof typeof SubscriptionStatus];
    return (subscrptionStatus == SubscriptionStatus.Void
      || subscrptionStatus == SubscriptionStatus.Cancelled
      || subscrptionStatus == SubscriptionStatus.Frozen
      || subscrptionStatus == SubscriptionStatus.SuspendedDueToNonPayment
      || subscrptionStatus == SubscriptionStatus.Upgraded
      || subscrptionStatus == SubscriptionStatus.Transfered
      || subscrptionStatus == SubscriptionStatus.NotRenewing
      || subscrptionStatus == SubscriptionStatus.CancelledDueToNonPayment);
  }

  isNonRecurringPlan() {
    return (this.subscriptionCategory.toString() == PlanCategory[PlanCategory.PaidInFull] || this.subscriptionCategory == PlanCategory.PaidInFull 
      || this.subscriptionCategory.toString() == PlanCategory[PlanCategory.DropIn] || this.subscriptionCategory == PlanCategory.DropIn);
  }


}
